import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';
var microAppRoutes = {
  path: '/brand',
  redirect: '/brand/',
  component: RootLayout,
  children: [{
    path: '*',
    name: 'BrandDetails',
    component: function component() {
      return import('@/layouts/MicroAppLayout');
    },
    meta: {// keepAlive: true
    }
  }]
};
export default microAppRoutes;